export default __webpack_public_path__ + "static/media/default-user.b74f31b4.svg";